<template>
  <div>
    <booking-info :booking-info="bookingInfoProp"></booking-info>
    <v-row class="mt-5">
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
      >
        <v-btn
          class="w-100"
          color="primary"
          @click="handleDairyRecord"
        >
          View Dairy Record
        </v-btn>
      </v-col>
      <v-col
        v-if="showCancelBtn"
        cols="12"
        sm="12"
        md="6"
        lg="6"
      >
        <v-btn
          class="w-100"
          dark
          @click="handleCancelConfirmDialog(false)"
        >
          Cancel Booking
        </v-btn>
      </v-col>
      <v-col
        v-if="showCancelBtn"
        cols="12"
        sm="12"
        md="6"
        lg="6"
      >
        <v-btn
          class="w-100"
          dark
          @click="handleCancelConfirmDialog(true)"
        >
          Cancel Booking and Deduct Ticket
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog
      v-model="cancelConfirmDialog"
      width="300px"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>Information</v-card-title>
        <div class="ml-5">
          <!-- Are you sure to cancel booking -->
          {{ cancelMessage }}
        </div>
        <v-card-actions class="justify-center">
          <v-btn
            @click="cancelConfirmDialog = false"
          >
            Back
          </v-btn>
          <v-btn
            color="primary"
            @click="handleCancel"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script setup>
import { ref, computed, toRefs, watch, onMounted } from 'vue'
import moment from '@/utils/moment'
import { formatDate, formatTime, hasRole } from '@/utils/helper'
import BookingInfo from './BookingInfo'
import { cancel, deleteItem } from '@/api/bookedCourse'

const cancelMessage = ref('')

const isLoading = ref(false)
const cancelConfirmDialog = ref(false)
const deductTicket = ref(false)

function handleCancelConfirmDialog(isDeductTicket) {
  cancelMessage.value = 'Are you sure to cancel booking'
  if (isDeductTicket) {
    deductTicket.value = true
    cancelMessage.value += ' deduct ticket'
  }
  cancelMessage.value += '?'
  cancelConfirmDialog.value = true
}

const props = defineProps({
  bookingInfoProp: {
    type: Object,
    default() {
      return {
        id: -1,
        bookingNo: 'BAM2200001',
        userRecord: {
          fullName: 'Paul Chan',
        },
        center: {
          description: 'Mong Kok',
        },
        courseDate: '2023-02-16',
        courseStartTime: '2023-02-16T01:00:00.000Z',
        courseEndTime: '2023-02-16T02:00:00.000Z',
      }
    },
  },
})

const showCancelBtn = ref(false)
const { bookingInfoProp } = toRefs(props)
watch(bookingInfoProp, (newVal, oldVal) => {
  // console.log('watch booking', newVal, oldVal)
  console.log('newVal.courseStartTime', newVal.courseStartTime)
  console.log('moment(newVal.courseStartTime).unix()', moment(newVal.courseStartTime).unix())
  console.log('moment().unix()', moment().unix())
  console.log("moment(newVal.courseStartTime).isSameOrAfter(moment(), 'day')", moment(newVal.courseStartTime).isSameOrAfter(moment(), 'day'))

  // console.log('newVal.bookingStatusId', newVal.bookingStatusId)
  if (moment(bookingInfoProp.value.courseStartTime).unix() > moment().unix() && newVal.courseStatusID === 1) {
    showCancelBtn.value = true
  } else {
    showCancelBtn.value = false
  }
})

const emits = defineEmits(['canceled', 'loading', 'open-diary'])
function handleDairyRecord() {
  // console.log('handleDairyRecord bookingInfoProp', bookingInfoProp)
  emits('open-diary')
}

const isStudent = ref(false)

onMounted(() => {
  console.log('moment().utc()', moment())
  console.log('bookingInfoProp.value.courseStartTime', bookingInfoProp.value.courseStartTime)
  console.log('moment(bookingInfoProp.value.courseStartTime).unix()', moment(bookingInfoProp.value.courseStartTime).unix())
  console.log('moment().unix()', moment().unix())
  console.log("moment(bookingInfoProp.value.courseStartTime).isSameOrAfter(moment(), 'day')", moment(bookingInfoProp.value.courseStartTime).isSameOrAfter(moment(), 'day'))

  // console.log('newVal.bookingStatusId', newVal.bookingStatusId)
  if (moment(bookingInfoProp.value.courseStartTime).unix() > moment().unix() && bookingInfoProp.value.courseStatusID === 1) {
    showCancelBtn.value = true
  } else {
    showCancelBtn.value = false
  }

  const roleArr = hasRole([1])
  if (roleArr.length > 0) {
    isStudent.value = true
  }
})

// This function handles the cancellation process for a booking.
function handleCancel() {
  // Log the current booking info for debugging purposes.
  console.log('handleCancel bookingInfoProp', bookingInfoProp)

  // Emit a 'loading' event with a value of true to indicate that the process has started.
  emits('loading', true)

  // console.log('moment().unix()', moment().unix())
  // console.log('moment(bookingInfoProp.value.courseStartTime).unix()', moment(bookingInfoProp.value.courseStartTime).unix())

  if (deductTicket.value) {
    cancel({
      id: bookingInfoProp.value.id || -1, // Use the booking ID or -1 if it's not available.
    }).then(response => {
      // Log the response for debugging purposes.
      console.log('handleCancel', response)

      // Check if the response code is 20000, indicating a successful operation.
      if (response.code === 20000) {
        // Emit a 'canceled' event to notify that the booking has been canceled.
        emits('canceled')
      }
    })
  } else {
    deleteItem({
      id: bookingInfoProp.value.id || -1, // Use the booking ID or -1 if it's not available.
    }).then(response => {
    // Log the response for debugging purposes.
      console.log('handleCancel', response)

      // Check if the response code is 20000, indicating a successful operation.
      if (response.code === 20000) {
      // Emit a 'canceled' event to notify that the booking has been canceled.
        emits('canceled')
      }
    })
  }
}
</script>
<style>
  .w-100{
    width: 100%;
  }
</style>
